import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CTASection.css';

const CTASection = () => {
  const navigate = useNavigate();

  const navigateToContact = () => {
    navigate('/contact');
  };

  return (
    <section className="cta-section section">
      <div className="container">
        <h2>Ready to enhance your business performance?</h2>
        <p>Let's work together.</p>
        <button className="btn btn-secondary large" onClick={navigateToContact}>Contact Us</button>
      </div>
    </section>
  );
};

export default CTASection;
